import { createIcon } from '@chakra-ui/icons';

export const Award = createIcon({
  displayName: 'Award',
  viewBox: '0 0 13 14',
  path: [
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24046)">
        <path
          d="M10.5625 13.5H0.8125C0.325 13.5 0 13.175 0 12.6875V1.3125C0 0.825 0.325 0.5 0.8125 0.5H10.5625V2.125H1.625V11.875H9.75V11.0625H11.375V12.6875C11.375 13.175 11.05 13.5 10.5625 13.5Z"
          fill="currentColor"
        />
        <path
          d="M13 5.375C13 3.99375 11.9438 2.9375 10.5625 2.9375C9.18125 2.9375 8.125 3.99375 8.125 5.375C8.125 6.10625 8.45 6.75625 8.9375 7.1625V10.25L10.5625 8.625L12.1875 10.25V7.1625C12.675 6.75625 13 6.10625 13 5.375Z"
          fill="currentColor"
        />
        <path d="M6.5 4.5625H3.25V6.1875H6.5V4.5625Z" fill="currentColor" />
        <path d="M7.3125 7.8125H3.25V9.4375H7.3125V7.8125Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_916_24046">
          <rect width="13" height="13" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
